import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect, useSelector } from 'react-redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import {
  breederProfileAvailabilityResourceDefinition,
  singleBreederProfileResourceDefinition
} from 'dpl/shared/utils/tptConnectResourceDefinitions';
import withCurrentUser from 'dpl/decorators/withCurrentUser';
import withToggle from 'dpl/decorators/withToggle';
import ApplicationEntry from 'dpl/adoption_application/components/ApplicationEntry';
import { BREED_ID } from 'dpl/constants/query_params';

import usePuppiesAndLitterAvailabilityCheck from '../hooks/usePuppiesAndLitterAvailabilityCheck';

function ApplicationEntryContainer(props) {
  const breedId = useSelector(({ queryParams }) => queryParams[BREED_ID]);
  const { breederProfileId } = useSelector(({ server }) => server);
  const { availablePuppiesForBreed } =
    usePuppiesAndLitterAvailabilityCheck(breedId);

  const {
    isFetching,
    value: {
      data: { can_override_availability: canOverrideAvailability }
    }
  } = useResourceQuery(
    breederProfileAvailabilityResourceDefinition(breederProfileId)
  );

  useEffect(() => {
    if (
      !availablePuppiesForBreed &&
      !isFetching &&
      !canOverrideAvailability &&
      props.breederProfileData.value.profile_url
    ) {
      window.location.href = props.breederProfileData.value.profile_url;
    }
  }, [
    props.breederProfileData.value.profile_url,
    canOverrideAvailability,
    isFetching
  ]);

  return <ApplicationEntry {...props} />;
}

ApplicationEntryContainer.propTypes = {
  buyerApplicationData: PropTypes.shape({
    meta: PropTypes.shape({
      isSuccess: PropTypes.bool
    }).isRequired
  }).isRequired,
  breederProfileData: PropTypes.shape({
    value: PropTypes.shape({
      accepting_applications: PropTypes.bool,
      profile_url: PropTypes.string
    }).isRequired
  }).isRequired
};

export default compose(
  withCurrentUser,
  withToggle({ propName: 'didSubmit' }),
  __DEPRECATED_defineResources(({ server: { breederProfileId } }) => ({
    breederProfileData:
      singleBreederProfileResourceDefinition(breederProfileId),
    buyerApplicationData: {
      url: `/api/breeder_profiles/${breederProfileId}/buyer_applications/show.json`,
      defaultValue: {
        buyer_application: {}
      }
    }
  })),
  connect(
    (
      _,
      {
        breederProfileData,
        buyerApplicationData,
        currentUser,
        onCloseClick,
        toggleOn,
        didSubmit,
        toggleOff
      }
    ) => ({
      isLoadingData:
        didSubmit ||
        !(currentUser.meta.isSuccess && buyerApplicationData.meta.isSuccess),
      onApplicationBeforeSubmit: toggleOn,
      onApplicationSubmit: () => {
        currentUser.fetch();
        buyerApplicationData.fetch().then(toggleOff);
      },
      onCloseClick:
        onCloseClick ||
        (() => {
          window.location = breederProfileData.value.profile_url;
        })
    })
  )
)(ApplicationEntryContainer);
